// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2[data-v-96824514]{font-size:2.5rem;font-weight:700;line-height:1;margin-bottom:1rem}@media(min-width:1260px){h2[data-v-96824514]{font-size:4rem}}.overview[data-v-96824514]{align-items:flex-start;border-bottom:1px solid #000;border-top:1px solid #000;display:flex;flex-direction:column;margin-top:1.5rem;padding:1.5rem 0}@media(min-width:1260px){.overview[data-v-96824514]{height:100%;margin-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
